export default "__VITE_ASSET__CEMQbeex__"